var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',_vm._b({},'v-avatar',_vm.attrs,false),[_c('v-img',{attrs:{"src":_vm.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }